/*
 * 公用方法
 */

import Vue from 'vue'
import { isEmbeddedIframe, shouldForceMobileLayout } from '@/embed-base'
import { reLaunchMiniHome, shouldUseNativeTabNav } from '@/common/mini-tab-nav.js'
import { navigateByEnv, navigateToArtistHome, getRuntimeEnv } from '@/common/navigate.js'

var utils = {
  formatNumber: function (num, unit = '万') {
    // if (!num) return
    let base = 10000
    if (num >= base) {
      const wan = num / base
      // 判断是否为整数
      if (wan % 1 === 0) {
        return `${wan}${unit}`
      } else {
        // 四舍五入保留一位小数
        return `${Math.round(wan * 10) / 10}${unit}`
      }
    } else {
      // return num.toString();
      return num
    }
  },
  // 价格换算（分换算成元）
  convertFenToYuan: function (fen) {
    return fen ? fen / 100.0 : ''
  },
  // 去除变量中的标签只保留文字内容
  stripTags(html) {
    var parser = new DOMParser()
    var doc = parser.parseFromString(html, 'text/html')
    return doc.body.textContent || ''
  },
  /**
   * 展示用字符串：null / undefined / 空 / 字面量 "null" → ''
   * @param {*} value
   * @returns {string}
   */
  orEmpty: function (value) {
    if (value == null) return ''
    const s = String(value).trim()
    if (!s || s === 'null' || s === 'undefined') return ''
    return String(value)
  },
  /** 万单位互动值展示（如 buzz_score），避免 365.2000000000005 */
  formatBuzzScoreW: function (num, decimals = 1) {
    if (num === null || num === undefined || num === '') return ''
    const value = Number(num)
    if (Number.isNaN(value)) return String(num)
    const factor = 10 ** decimals
    const rounded = Math.round(value * factor) / factor
    return String(parseFloat(rounded.toFixed(decimals)))
  },
  // 设置时间格式
  setTimeFormat(date) {
    let dateLength = date.length
    let dateFormat = 'YYYY.M.D'
    switch (dateLength) {
      case 4:
        dateFormat = 'YYYY'
        break
      case 7:
        dateFormat = 'YYYY.M'
        break
      default:
        dateFormat = 'YYYY.M.D'
        break
    }
    return dateFormat
  },
  // 切分数组
  chunkArray(array, chunkSize) {
    const chunks = []
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize))
    }
    return chunks
  },
  // 设置阿里云图片缩放
  setImgResize(imgUrl, width) {
    // let imgResize = `x-oss-process=image/resize,w_${width},m_lfit`
    let imgResize = `x-oss-process=image/resize,w_${width},m_mfit`
    let connector = utils.setUrlConnector(imgUrl)
    return connector + imgResize
  },
  // 设置阿里云图片缩放(根据宽高自动缩放)
  setImgResizeType(imgUrl, width, height, type) {
    let imgResize = `x-oss-process=image/resize,w_${width},h_${height},${type}`
    let connector = utils.setUrlConnector(imgUrl)
    return connector + imgResize
  },
  // 设置阿里云视频第一帧封面图
  setVideoSnapshot(videoUrl) {
    let videoSnapshot = `&x-oss-process=video/snapshot,t_1,m_fast`
    let connector = utils.setUrlConnector(videoUrl)
    return connector + videoSnapshot
  },
  // 设置连接符
  setUrlConnector(url) {
    let connector = '?'
    if (url.indexOf('?') > -1) {
      connector = '&'
    }
    return connector
  },
  isMobileOrPc: function () {
    let terminal = utils.isMobile() ? 'mobile' : 'pc'
    return terminal
  },
  // 价格换算（分换算成元）
  convertFenToYuan: function (fen) {
    return fen ? fen / 100.0 : ''
  },

  // 获取网址链接里参数值
  GetQueryString: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  },
  // 获取链接中的所有参数
  getUrlParams: function () {
    let url = window.location.href
    let params = url.split('?')[1]
    if (!params) return {}
    params = params.split('&')
    let paramsObj = {}
    params.forEach((param) => {
      let key = param.split('=')[0]
      let value = param.split('=')[1]
      if (key) {
        try {
          paramsObj[decodeURIComponent(key)] = value ? decodeURIComponent(value) : ''
        } catch (e) {
          paramsObj[key] = value
        }
      }
    })
    return paramsObj
  },
  /**
   * ticket 静默登录进行中（地址栏还有未兑换 ticket，或请求已发出）
   * 以 window.location 为准：history.replaceState 清掉 ticket 后 Vue query 可能仍是旧值
   */
  isSilentLoginPending: function () {
    if (typeof localStorage !== 'undefined' && (localStorage.getItem('tokenLogin') || localStorage.getItem('token'))) {
      return false
    }
    if (typeof window !== 'undefined' && window.__MP_SILENT_LOGIN_PENDING__) {
      return true
    }
    try {
      const params = this.getUrlParams()
      return !!(params && params.ticket)
    } catch (e) {
      return false
    }
  },
  // 图片数组变成字符串
  imgArrToString: function (arr) {
    var str = ''
    if (arr.length > 0) {
      arr.forEach((v) => {
        if (v.hasOwnProperty('response')) {
          str += v.response.data + ','
        } else if (v.hasOwnProperty('url')) {
          str += v.url + ','
        } else {
          str += v + ','
        }
      })
      // 去除字符串最后一个逗号
      str = str.substr(0, str.length - 1)
    }
    return str
  },

  // 判断是否手机访问（嵌在 uni-app H5 web-view iframe 时按手机处理）
  isMobile: function () {
    if (shouldForceMobileLayout()) return true
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|MicroMessenger)/i
    )
    return flag
  },
  // 判断是否安卓手机
  isAndroid: function () {
    // var u = navigator.userAgent;
    // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    // if (isAndroid) {}
    let flag = navigator.userAgent.match(/(Android|Adr)/i)
    return flag
  },
  // 判断是否苹果手机
  isIphone: function () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad)/i)
    return flag
  },

  // 判断是否为null 不为空为false  null为true
  isEmpty: function (res) {
    if (res == '' || typeof res == undefined || res == null || Object.keys(res).length === 0) {
      return true
    } else {
      return false
    }
  },
  // 滚动到顶部
  scrollToTop: function () {
    const c = document.documentElement.scrollTop || document.body.scrollTop
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop)
      window.scrollTo(0, c - c / 8)
    }
  },
  /**
   * 复制
   * @param {*} value
   */
  copyText(value) {
    const safeText = value

    const textarea = document.createElement('textarea')
    textarea.value = safeText
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand('copy')
    } catch (e) {
      console.log('复制失败，请手动复制')
    }

    document.body.removeChild(textarea)
  },

  /********************************************* 关于数组 ******************************/
  /**
   * @param  {arr} 数组
   * @param  {fn} 回调函数
   * @return {undefined}
   */
  each: function (arr, fn) {
    fn = fn || Function
    var a = []
    var args = Array.prototype.slice.call(arguments, 1)
    for (var i = 0; i < arr.length; i++) {
      var res = fn.apply(arr, [arr[i], i].concat(args))
      if (res != null) a.push(res)
    }
  },

  /**
   * @param  {arr} 数组
   * @param  {fn} 回调函数
   * @param  {thisObj} this指向
   * @return {Array}
   */
  map: function (arr, fn, thisObj) {
    var scope = thisObj || window
    var a = []
    for (var i = 0, j = arr.length; i < j; ++i) {
      var res = fn.call(scope, arr[i], i, this)
      if (res != null) a.push(res)
    }
    return a
  },

  /**
   * @param  {arr} 数组
   * @param  {type} 1：从小到大   2：从大到小   3：随机
   * @return {Array}
   */
  sort: function (arr, type = 1) {
    return arr.sort((a, b) => {
      switch (type) {
        case 1:
          return a - b
        case 2:
          return b - a
        case 3:
          return Math.random() - 0.5
        default:
          return arr
      }
    })
  },
  /**
   * 去重
   */
  unique: function (arr) {
    if (Array.hasOwnProperty('from')) {
      return Array.from(new Set(arr))
    } else {
      var n = {},
        r = []
      for (var i = 0; i < arr.length; i++) {
        if (!n[arr[i]]) {
          n[arr[i]] = true
          r.push(arr[i])
        }
      }
      return r
    }
  },

  /**
   * 求两个集合的并集
   */
  union: function (a, b) {
    var newArr = a.concat(b)
    return this.unique(newArr)
  },

  /**
   * 求两个集合的交集
   */
  intersect(a, b) {
    var _this = this
    a = this.unique(a)
    return this.map(a, function (o) {
      return _this.contains(b, o) ? o : null
    })
  },

  /**
   * 删除其中一个元素
   */
  remove(arr, ele) {
    var index = arr.indexOf(ele)
    if (index > -1) {
      arr.splice(index, 1)
    }
    return arr
  },

  /**
   * 将类数组转换为数组的方法
   */
  formArray: function (ary) {
    var arr = []
    if (Array.isArray(ary)) {
      arr = ary
    } else {
      arr = Array.prototype.slice.call(ary)
    }
    return arr
  },

  /**
   * 最大值
   */
  max: function (arr) {
    return Math.max.apply(null, arr)
  },

  /**
   * 最小值
   */
  min: function (arr) {
    return Math.min.apply(null, arr)
  },

  /**
   * 求和
   */
  sum: function (arr) {
    return arr.reduce((pre, cur) => {
      return pre + cur
    })
  },

  /**
   * 平均值
   */
  average: function (arr) {
    return this.sum(arr) / arr.length
  },

  /**
   * 判断类型集合
   * @param {*} str
   * @param {*} type
   */
  checkStr: function (str, type) {
    switch (type) {
      case 'phone': //手机号码
        return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(str)
      case 'tel': //座机
        return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str)
      case 'card': //身份证
        return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str)
      case 'pwd': //密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
        return /^[a-zA-Z]\w{5,17}$/.test(str)
      case 'postal': //邮政编码
        return /[1-9]\d{5}(?!\d)/.test(str)
      case 'QQ': //QQ号
        return /^[1-9][0-9]{4,9}$/.test(str)
      case 'email': //邮箱
        return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str)
      case 'money': //金额(小数点2位)
        return /^\d*(?:\.\d{0,2})?$/.test(str)
      case 'URL': //网址
        return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(str)
      case 'IP': //IP
        return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(str)
      case 'date': //日期时间
        return (
          /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) ||
          /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
        )
      case 'number': //数字
        return /^[0-9]$/.test(str)
      case 'english': //英文
        return /^[a-zA-Z]+$/.test(str)
      case 'chinese': //中文
        return /^[\\u4E00-\\u9FA5]+$/.test(str)
      case 'lower': //小写
        return /^[a-z]+$/.test(str)
      case 'upper': //大写
        return /^[A-Z]+$/.test(str)
      case 'HTML': //HTML标记
        return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str)
      default:
        return true
    }
  },

  /**
   * 将阿拉伯数字翻译成中文的大写数字
   */
  numberToChinese: function (num) {
    var AA = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十')
    var BB = new Array('', '十', '百', '仟', '萬', '億', '点', '')
    var a = ('' + num).replace(/(^0*)/g, '').split('.'),
      k = 0,
      re = ''
    for (var i = a[0].length - 1; i >= 0; i--) {
      switch (k) {
        case 0:
          re = BB[7] + re
          break
        case 4:
          if (!new RegExp('0{4}//d{' + (a[0].length - i - 1) + '}$').test(a[0])) re = BB[4] + re
          break
        case 8:
          re = BB[5] + re
          BB[7] = BB[5]
          k = 0
          break
      }
      if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re
      if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re
      k++
    }

    if (a.length > 1) {
      // 加上小数部分(如果有小数部分)
      re += BB[6]
      for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)]
    }
    if (re == '一十') re = '十'
    if (re.match(/^一/) && re.length == 3) re = re.replace('一', '')
    return re
  },
  /**
   * 将数字转换为大写金额
   */
  changeToChinese: function () {
    //判断如果传递进来的不是字符的话转换为字符
    if (typeof Num == 'number') {
      Num = new String(Num)
    }
    Num = Num.replace(/,/g, '') //替换tomoney()中的“,”
    Num = Num.replace(/ /g, '') //替换tomoney()中的空格
    Num = Num.replace(/￥/g, '') //替换掉可能出现的￥字符
    if (isNaN(Num)) {
      //验证输入的字符是否为数字
      //alert("请检查小写金额是否正确");
      return ''
    }
    //字符处理完毕后开始转换，采用前后两部分分别转换
    var part = String(Num).split('.')
    var newchar = ''
    //小数点前进行转化
    for (var i = part[0].length - 1; i >= 0; i--) {
      if (part[0].length > 10) {
        return ''
        //若数量超过拾亿单位，提示
      }
      var tmpnewchar = ''
      var perchar = part[0].charAt(i)
      switch (perchar) {
        case '0':
          tmpnewchar = '零' + tmpnewchar
          break
        case '1':
          tmpnewchar = '壹' + tmpnewchar
          break
        case '2':
          tmpnewchar = '贰' + tmpnewchar
          break
        case '3':
          tmpnewchar = '叁' + tmpnewchar
          break
        case '4':
          tmpnewchar = '肆' + tmpnewchar
          break
        case '5':
          tmpnewchar = '伍' + tmpnewchar
          break
        case '6':
          tmpnewchar = '陆' + tmpnewchar
          break
        case '7':
          tmpnewchar = '柒' + tmpnewchar
          break
        case '8':
          tmpnewchar = '捌' + tmpnewchar
          break
        case '9':
          tmpnewchar = '玖' + tmpnewchar
          break
      }
      switch (part[0].length - i - 1) {
        case 0:
          tmpnewchar = tmpnewchar + '元'
          break
        case 1:
          if (perchar != 0) tmpnewchar = tmpnewchar + '拾'
          break
        case 2:
          if (perchar != 0) tmpnewchar = tmpnewchar + '佰'
          break
        case 3:
          if (perchar != 0) tmpnewchar = tmpnewchar + '仟'
          break
        case 4:
          tmpnewchar = tmpnewchar + '万'
          break
        case 5:
          if (perchar != 0) tmpnewchar = tmpnewchar + '拾'
          break
        case 6:
          if (perchar != 0) tmpnewchar = tmpnewchar + '佰'
          break
        case 7:
          if (perchar != 0) tmpnewchar = tmpnewchar + '仟'
          break
        case 8:
          tmpnewchar = tmpnewchar + '亿'
          break
        case 9:
          tmpnewchar = tmpnewchar + '拾'
          break
      }
      var newchar = tmpnewchar + newchar
    }
    //小数点之后进行转化
    if (Num.indexOf('.') != -1) {
      if (part[1].length > 2) {
        // alert("小数点之后只能保留两位,系统将自动截断");
        part[1] = part[1].substr(0, 2)
      }
      for (i = 0; i < part[1].length; i++) {
        tmpnewchar = ''
        perchar = part[1].charAt(i)
        switch (perchar) {
          case '0':
            tmpnewchar = '零' + tmpnewchar
            break
          case '1':
            tmpnewchar = '壹' + tmpnewchar
            break
          case '2':
            tmpnewchar = '贰' + tmpnewchar
            break
          case '3':
            tmpnewchar = '叁' + tmpnewchar
            break
          case '4':
            tmpnewchar = '肆' + tmpnewchar
            break
          case '5':
            tmpnewchar = '伍' + tmpnewchar
            break
          case '6':
            tmpnewchar = '陆' + tmpnewchar
            break
          case '7':
            tmpnewchar = '柒' + tmpnewchar
            break
          case '8':
            tmpnewchar = '捌' + tmpnewchar
            break
          case '9':
            tmpnewchar = '玖' + tmpnewchar
            break
        }
        if (i == 0) tmpnewchar = tmpnewchar + '角'
        if (i == 1) tmpnewchar = tmpnewchar + '分'
        newchar = newchar + tmpnewchar
      }
    }
    //替换所有无用汉字
    while (newchar.search('零零') != -1) newchar = newchar.replace('零零', '零')
    newchar = newchar.replace('零亿', '亿')
    newchar = newchar.replace('亿万', '亿')
    newchar = newchar.replace('零万', '万')
    newchar = newchar.replace('零元', '元')
    newchar = newchar.replace('零角', '')
    newchar = newchar.replace('零分', '')
    if (newchar.charAt(newchar.length - 1) == '元') {
      newchar = newchar + '整'
    }
    return newchar
  },

  /********************************************* String 字符串操作 ******************************/

  /**
   * 去除空格
   * @param  {str}
   * @param  {type}
   * type:  1-所有空格  2-前后空格  3-前空格 4-后空格
   * @return {String}
   */
  trim: function (str, type) {
    type = type || 1
    switch (type) {
      case 1:
        return str.replace(/\s+/g, '')
      case 2:
        return str.replace(/(^\s*)|(\s*$)/g, '')
      case 3:
        return str.replace(/(^\s*)/g, '')
      case 4:
        return str.replace(/(\s*$)/g, '')
      default:
        return str
    }
  },

  /*
   *  检测密码强度
   */
  checkPwd: function (str) {
    var Lv = 0
    if (str.length < 6) {
      return Lv
    }
    if (/[0-9]/.test(str)) {
      Lv++
    }
    if (/[a-z]/.test(str)) {
      Lv++
    }
    if (/[A-Z]/.test(str)) {
      Lv++
    }
    if (/[\.|-|_]/.test(str)) {
      Lv++
    }
    return Lv
  },

  /**
   * 函数节流器
   * @param  {Function} fn 需要执行性的函数
   * @param  {number} time 时间戳
   * @param  {number} interval 间隔时间
   */
  debouncer: function (fn, time, interval = 200) {
    if (time - (window.debounceTimestamp || 0) > interval) {
      fn && fn()
      window.debounceTimestamp = time
    }
  },

  /**
   * 在字符串中插入新字符串
   * @param {string} soure 源字符
   * @param {string} index 插入字符的位置
   * @param {string} newStr 需要插入的字符
   * @returns {string} 返回新生成的字符
   */
  insertStr: function (soure, index, newStr) {
    var str = soure.slice(0, index) + newStr + soure.slice(index)
    return str
  },

  /**
   * 判断两个对象是否键值相同
   * @param  {Object}  a 第一个对象
   * @param  {Object}  b 第一个对象
   * @return {Boolean}   相同返回true，否则返回false
   */
  isObjectEqual: function (a, b) {
    var aProps = Object.getOwnPropertyNames(a)
    var bProps = Object.getOwnPropertyNames(b)

    if (aProps.length !== bProps.length) {
      return false
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i]
      if (a[propName] !== b[propName]) {
        return false
      }
    }
    return true
  },

  /**
   * 16进制颜色转RGB\RGBA字符串
   * @param  {String} val 16进制颜色值
   * @param  {Number} opa 不透明度，取值0~1
   * @return {String}     转换后的RGB或RGBA颜色值
   */
  colorToRGB: function (val, opa) {
    var pattern = /^(#?)[a-fA-F0-9]{6}$/ //16进制颜色值校验规则
    var isOpa = typeof opa == 'number' //判断是否有设置不透明度

    if (!pattern.test(val)) {
      //如果值不符合规则返回空字符
      return ''
    }

    var v = val.replace(/#/, '') //如果有#号先去除#号
    var rgbArr = []
    var rgbStr = ''

    for (var i = 0; i < 3; i++) {
      var item = v.substring(i * 2, i * 2 + 2)
      var num = parseInt(item, 16)
      rgbArr.push(num)
    }

    rgbStr = rgbArr.join()
    rgbStr = 'rgb' + (isOpa ? 'a' : '') + '(' + rgbStr + (isOpa ? ',' + opa : '') + ')'
    return rgbStr
  },

  /**
   * 追加url参数
   * @param {string} url url参数
   * @param {string|object} key 名字或者对象
   * @param {string} value 值
   * @return {string} 返回新的url
   * @example
   * appendQuery('lechebang.com', 'id', 3);
   * appendQuery('lechebang.com?key=value', { cityId: 2, cityName: '北京'});
   */
  appendQuery: function (url, key, value) {
    var options = key
    if (typeof options == 'string') {
      options = {}
      options[key] = value
    }
    options = $.param(options)
    if (url.includes('?')) {
      url += '&' + options
    } else {
      url += '?' + options
    }
    return url
  },

  /**
   * 判断a数组是否包含b数组中
   */
  getArrRepeat: function (arr1, arr2) {
    return arr1.filter((item, index) => {
      return arr2.includes(item)
    })
  },

  createSpriteAnimation: function (options) {
    // 获取配置参数
    const { canvas, image, frameWidth, frameHeight, totalFrames, fps = 60, scale = 1, loop = true } = options

    const ctx = canvas.getContext('2d')
    let currentFrame = 0
    let lastTime = 0
    let isPlaying = true
    let animationId = null

    // 将px转换为rem
    function pxToRem(px) {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
      return px / rootFontSize
    }

    // 将rem转换为px
    function remToPx(rem) {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
      return rem * rootFontSize
    }

    // 设置canvas尺寸（考虑rem和缩放）
    function resizeCanvas() {
      const frameWidthRem = pxToRem(frameWidth * scale)
      const frameHeightRem = pxToRem(frameHeight * scale)

      canvas.style.width = `${frameWidthRem}rem`
      canvas.style.height = `${frameHeightRem}rem`

      // 设置实际绘制尺寸（考虑设备像素比）
      const devicePixelRatio = window.devicePixelRatio || 1
      canvas.width = remToPx(frameWidthRem) * devicePixelRatio
      canvas.height = remToPx(frameHeightRem) * devicePixelRatio

      // 缩放上下文以匹配CSS尺寸
      ctx.scale(devicePixelRatio, devicePixelRatio)
    }

    // 绘制当前帧
    function draw() {
      // 清除画布
      ctx.clearRect(0, 0, remToPx(pxToRem(frameWidth * scale)), remToPx(pxToRem(frameHeight * scale)))

      // 计算当前帧在雪碧图中的位置
      const frameX = (currentFrame % Math.floor(image.width / frameWidth)) * frameWidth
      const frameY = Math.floor(currentFrame / Math.floor(image.width / frameWidth)) * frameHeight

      // 绘制图像（考虑缩放）
      ctx.drawImage(image, frameX, frameY, frameWidth, frameHeight, 0, 0, frameWidth * scale, frameHeight * scale)
    }

    // 动画循环
    function animate(timestamp) {
      if (!isPlaying) return

      if (!lastTime) lastTime = timestamp
      const deltaTime = timestamp - lastTime

      // 根据fps计算帧间隔时间
      const frameInterval = 1000 / fps

      if (deltaTime > frameInterval) {
        // 更新帧
        currentFrame++

        if (currentFrame >= totalFrames) {
          if (loop) {
            currentFrame = 0
          } else {
            stop()
            return
          }
        }

        draw()
        lastTime = timestamp - (deltaTime % frameInterval)
      }

      animationId = requestAnimationFrame(animate)
    }

    // 开始动画
    function start() {
      if (!isPlaying) {
        isPlaying = true
        lastTime = 0
        animationId = requestAnimationFrame(animate)
      }
    }

    // 停止动画
    function stop() {
      isPlaying = false
      if (animationId) {
        cancelAnimationFrame(animationId)
        animationId = null
      }
    }

    // 重置动画
    function reset() {
      currentFrame = 0
      draw()
    }

    // 初始化
    resizeCanvas()
    window.addEventListener('resize', resizeCanvas)
    draw()
    start()

    // 返回控制方法
    return {
      start,
      stop,
      reset,
      getCurrentFrame: () => currentFrame,
      setFrame: (frame) => {
        currentFrame = Math.max(0, Math.min(totalFrames - 1, frame))
        draw()
      },
    }
  },
  /**
   * 回到首页：iframe / 小程序跳外壳 tab 首页，其它环境走 H5 /
   */
  goMiniOrH5Home: function (router) {
    if (shouldUseNativeTabNav() && reLaunchMiniHome()) return true
    this.checkMiniProgram((isMiniProgram) => {
      if (isMiniProgram && reLaunchMiniHome()) return
      if (router) {
        router.push({ path: '/' })
      }
    })
    return true
  },
  /**
   * 是否嵌在 uni-app H5 的 web-view iframe 里（含 /proxy-webview/）
   */
  isEmbeddedInUniH5: function () {
    return isEmbeddedIframe()
  },
  /**
   * 把 H5 登录/退出同步给宿主 uni-app H5（仅 iframe web-view）
   * @param {{ action: 'login'|'logout', token?: string, device_id?: string, expires?: string, user?: object }} payload
   */
  notifyUniH5Auth: function (payload) {
    if (!payload || !payload.action) return
    if (!this.isEmbeddedInUniH5()) return
    const token = payload.token || localStorage.getItem('tokenLogin') || localStorage.getItem('token') || ''
    try {
      window.parent.postMessage(
        {
          type: 'H5_AUTH',
          action: payload.action,
          token: payload.action === 'logout' ? '' : token,
          device_id: payload.device_id || localStorage.getItem('device_id') || '',
          expires: payload.expires || localStorage.getItem('expires') || '',
          user: payload.user || null,
        },
        '*'
      )
    } catch (e) {
      // ignore
    }
  },
  /**
   * 嵌在 uni-app H5 web-view 时回宿主首页。独立打开 H5 返回 false。
   * @returns {Boolean}
   */
  goUniH5HomeIfEmbedded: function () {
    if (!this.isEmbeddedInUniH5()) return false
    return reLaunchMiniHome()
  },
  /**
   * 判断当前是否在微信小程序环境
   * @param {Function} callback 回调函数
   */
  checkMiniProgram: function (callback) {
    let callbackCalled = false
    const safeCallback = (result) => {
      if (!callbackCalled) {
        callbackCalled = true
        if (callback) callback(result)
      }
    }

    try {
      if (typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.getEnv === 'function') {
        wx.miniProgram.getEnv((res) => {
          safeCallback(res.miniprogram)
        })
        setTimeout(() => {
          safeCallback(false)
        }, 500)
      } else {
        safeCallback(false)
      }
    } catch (e) {
      safeCallback(false)
    }
  },
  _canStartShellLogin: function () {
    if (window.__MP_SILENT_LOGIN_PENDING__) return false
    const loginSuccessAt = window.__MP_LOGIN_SUCCESS_AT__ || 0
    if (loginSuccessAt && Date.now() - loginSuccessAt < 10000) return false
    if (window.__MP_LOGIN_REDIRECTING__) return false
    const now = Date.now()
    const last = window.__MP_LOGIN_REDIRECT_TS__ || 0
    if (now - last < 2500) return false
    return true
  },
  _releaseShellLoginLock: function (opts) {
    window.__MP_LOGIN_REDIRECTING__ = ''
    if (this._shellLoginUnlockTimer) {
      clearTimeout(this._shellLoginUnlockTimer)
      this._shellLoginUnlockTimer = null
    }
    if (opts && opts.allowRetryNow) {
      window.__MP_LOGIN_REDIRECT_TS__ = 0
    }
  },
  _unlockShellLoginIfCancelled: function () {
    if (localStorage.getItem('tokenLogin') || localStorage.getItem('token')) return
    const awaiting = sessionStorage.getItem('MP_AWAITING_LOGIN') === '1'
    this._releaseShellLoginLock({ allowRetryNow: awaiting })
  },
  _markShellLoginStart: function () {
    window.__MP_LOGIN_REDIRECTING__ = '1'
    window.__MP_LOGIN_REDIRECT_TS__ = Date.now()
    sessionStorage.setItem('MP_AWAITING_LOGIN', '1')
    if (this._shellLoginUnlockTimer) clearTimeout(this._shellLoginUnlockTimer)
    this._shellLoginUnlockTimer = setTimeout(() => {
      window.__MP_LOGIN_REDIRECTING__ = ''
      this._shellLoginUnlockTimer = null
    }, 2500)
  },
  _buildH5LoginUrl: function (redirectUrl) {
    const currentUrl = encodeURIComponent(window.location.href)
    let loginUrl = '/subpages/login/index?from=h5&fromUrl=' + currentUrl
    if (redirectUrl) {
      loginUrl += '&redirect_url=' + encodeURIComponent(redirectUrl)
    }
    return { loginUrl, currentUrl }
  },
  requestShellLogin: function (redirectUrl) {
    if (!this._canStartShellLogin()) return false
    this._markShellLoginStart()
    const { loginUrl, currentUrl } = this._buildH5LoginUrl(redirectUrl)
    try {
      window.parent.postMessage(
        {
          type: 'H5_LOGIN',
          payload: {
            url: loginUrl,
            fromUrl: decodeURIComponent(currentUrl),
          },
        },
        '*'
      )
      return true
    } catch (e) {
      this._releaseShellLoginLock({ allowRetryNow: true })
      return false
    }
  },
  /**
   * 跳转到外壳登录页（小程序 navigateTo / uni-app H5 iframe postMessage）
   * @param {String} [redirectUrl] 登录成功后跳转的小程序页面路径
   */
  miniProgramLogin: function (redirectUrl) {
    if (isEmbeddedIframe()) {
      this.requestShellLogin(redirectUrl)
      return
    }
    this.checkMiniProgram((isMiniProgram) => {
      if (!isMiniProgram) return
      if (!this._canStartShellLogin()) return
      this._markShellLoginStart()
      const { loginUrl } = this._buildH5LoginUrl(redirectUrl)
      wx.miniProgram.navigateTo({
        url: loginUrl,
      })
    })
  },
  /**
   * 微信网页授权。嵌在 iframe 里禁止跳 /wx/oauth，改走外壳登录 + ticket
   */
  goWeChatOauth: function (apiURL, returnUrl) {
    if (isEmbeddedIframe()) {
      this.requestShellLogin()
      return
    }
    const api = apiURL || process.env.VUE_APP_API_BASE_URL || ''
    const back = returnUrl || window.location.href
    location.href = api + '/wx/oauth?returnuri=' + encodeURIComponent(back)
  },
  /**
   * 按运行环境跳转（App / 小程序 / H5 iframe / 纯 H5）
   * @param {String} nativePath App/小程序/iframe 内的原生路径
   * @param {{ h5Path?: string, h5Url?: string }} [options]
   */
  navigateByEnv: function (nativePath, options) {
    return navigateByEnv(nativePath, options)
  },
  /**
   * 跳转明星艺人主页
   * App / 小程序 / H5 iframe → /subpages/stars/profile
   * 纯 H5 → 新版 H5 域名艺人主页
   */
  navigateToArtistHome: function (username) {
    return navigateToArtistHome(username)
  },
  getRuntimeEnv: function () {
    return getRuntimeEnv()
  },
  /**
   * H5跳转到小程序相关页面
   * @param {String} url 小程序页面路径
   */
  navigateToMiniProgram: function (url) {
    this.checkMiniProgram((isMiniProgram) => {
      if (isMiniProgram) {
        let separator = url.indexOf('?') !== -1 ? '&' : '?'
        let currentUrl = encodeURIComponent(window.location.href)
        this.postMessageToMiniProgram({
          type: 'H5_FORM_URL',
          fromUrl: currentUrl,
        })
        wx.miniProgram.navigateTo({
          url: url + separator + 'fromUrl=' + currentUrl,
        })
      }
    })
  },
  /**
   * 和小程序通信的方法
   * @param {Object} data 发送给小程序的数据
   */
  postMessageToMiniProgram: function (data) {
    this.checkMiniProgram((isMiniProgram) => {
      if (isMiniProgram) {
        wx.miniProgram.postMessage({ data: data })
      }
    })
  },
  /**
   * 全局监听app h5 postmessage传值
   * @param {Function} callback 回调函数
   */
  listenMiniProgramMessage: function (callback) {
    // window.addEventListener('message', (event) => {
    //   const data = event && event.data ? event.data : null
    //   if (data && callback) callback(data)
    //   const params = utils.getUrlParams()
    //   if (params && params.ticket && callback) {
    //     try {
    //       callback(params)
    //     } catch (e) {
    //       console.error('Failed to handle ticket from URL:', e)
    //     }
    //   }
    // })
    // 监听 pageshow（小程序 web-view 返回 / H5 iframe 从隐藏变为可见）
    window.addEventListener('pageshow', (e) => {
      // console.log('pageshow', e)
      if (e.isTrusted) {
        const params = utils.getUrlParams()
        // console.log('params', params)
        if (params && params.ticket && callback) {
          try {
            if (params.ticket) params.ticket = decodeURIComponent(params.ticket)
            if (params.device_id) params.device_id = decodeURIComponent(params.device_id)
            callback(params)
          } catch (e) {
            console.error('Failed to handle ticket from URL:', e)
          }
        }
      }
    })
  },
  /**
   * 转换安卓输入法生成的文本表情为Unicode表情符号
   * @param {String} text 需要转换的文本
   * @return {String} 转换后的文本
   */
  convertAndroidEmoji: function (text) {
    if (!text || typeof text !== 'string') return text

    // 安卓输入法常见的文本表情映射表
    const emojiMap = {
      '/:basketb': '🏀',
      '/:basket': '🏀',
    }

    let result = text
    // 替换所有已知的文本表情
    for (const [key, value] of Object.entries(emojiMap)) {
      result = result.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), value)
    }

    return result
  },
}

;(function bindShellLoginUnlock() {
  if (typeof window === 'undefined' || window.__MP_SHELL_LOGIN_UNLOCK_BOUND__) return
  window.__MP_SHELL_LOGIN_UNLOCK_BOUND__ = true
  const unlock = () => utils._unlockShellLoginIfCancelled()
  window.addEventListener('pageshow', unlock)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') unlock()
  })
  window.addEventListener('message', (event) => {
    const data = event && event.data
    if (data && data.type === 'H5_LOGIN_CANCELLED') unlock()
  })
})()

Vue.prototype.$utils = utils

export default {
  utils,
}
